"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var styles = {
  "button": "button_1cbp8i",
  "toggle-button": "toggle-button_2Gtl6T",
  "toggleButton": "toggle-button_2Gtl6T",
  "primary": "primary_1Lxve_",
  "active": "active_1RqHPA",
  "secondary": "secondary_2-aWCa",
  "content": "content_37CL6I",
  "label": "label_EOCkQp",
  "arrow": "arrow_pQhA_m",
  "expanded": "expanded_ZOjBpE"
}; 
require('./ToggleButton.css');
const ToggleButton = ({
  label,
  onClick,
  active = false,
  className,
  controls,
  expanded = false,
  isFocused,
  type = 'primary'
}) => /*#__PURE__*/_react.default.createElement(_Button.default, {
  kind: "tertiary",
  noFill: true,
  onClick: onClick,
  isFocused: isFocused,
  "aria-expanded": expanded,
  "aria-controls": controls,
  "aria-haspopup": "listbox",
  className: (0, _classnames.default)(styles.button, styles.toggleButton, {
    [styles.primary]: type === 'primary',
    [styles.secondary]: type === 'secondary',
    [styles.active]: active
  }, className)
}, /*#__PURE__*/_react.default.createElement("div", {
  className: styles.content
}, /*#__PURE__*/_react.default.createElement("span", {
  className: styles.label
}, label), /*#__PURE__*/_react.default.createElement(_Icon.default, {
  name: "arrow-down-small",
  size: "xs",
  className: (0, _classnames.default)(styles.arrow, {
    [styles.expanded]: expanded
  })
})));
var _default = exports.default = ToggleButton;
//# sourceMappingURL=ToggleButton.js.map